import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import { reducer as auth } from "@onmo/auth";
import popup from "./slices/popup";
import shop from "./slices/shop";
import alert from "./slices/alert";
import user from "./slices/user";
import theme from "./slices/theme";

export const store = configureStore({
  reducer: {
    auth,
    popup,
    shop,
    alert,
    user,
    theme,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export type AsyncAppThunk<ReturnType = Promise<void>> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
